import { Component, Input, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';
import { selectorCoreSelectedInstance } from '@bepatient/core';
import { CommonUtilsService } from '../services/common-utils.service';
import chroma from 'chroma-js';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'bepatient-network-check-modal',
  templateUrl: './phone-check.component.html',
  styleUrls: ['./phone-check.component.scss'],
  standalone: false
})
export class PhoneCheckModalComponent {
  private modalCtrl = inject(ModalController);
  private store = inject(Store);
  private commonUtils = inject(CommonUtilsService);
  translate = inject(TranslateService);

  _instance_color: string;
  _instance_color_alpha: string;

  @Input() mode: 'network' | 'full' = 'full'; // Later can be used to support multiple checks.
  @Input() set instanceColor(value: string) {
    this._instance_color = value;
    this._instance_color_alpha = value ? chroma(value).alpha(0.2).css() : value;
  }

  checking = false;
  isChecked = false;
  networkStatus: 'idle' | 'loading' | 'success' | 'fail' = 'idle';
  networkMessage = '';
  platform = '';

  dismiss() {
    this.modalCtrl.dismiss('', '', 'phone-check-modal');
  }

  async startCheck() {
    this.checking = true;

    this.networkStatus = 'loading';
    await new Promise(res => setTimeout(res, 1000));

    const instance = await firstValueFrom(
      this.store.select(selectorCoreSelectedInstance).pipe(take(1))
    );
    const baseUrl = instance?.url;
    const network = await this.commonUtils.checkNetworkConnection(baseUrl);
    this.networkStatus = network.ok ? 'success' : 'fail';
    this.networkMessage = network.message;

    // TODO: Use later, when downlink will be available in safari.
    // downlink is not supported in safari, downlink return connection speed
    // const status = await Network.getStatus();
    // if (!status.connected) {
    //     this.networkStatus = 'fail';
    //     this.networkMessage = 'You are currently offline. Please check your Internet connection.';
    // } else {
    //     const connection =
    //         (navigator as any).connection ||
    //         (navigator as any).mozConnection ||
    //         (navigator as any).webkitConnection;

    //     const effectiveType = connection?.effectiveType || '';
    //     const downlink = connection?.downlink || 0;

    //     console.log(effectiveType, downlink);

    //     if (effectiveType === '2g' || effectiveType === 'slow-2g' || downlink < 0.5) {
    //         this.networkStatus = 'fail';
    //         this.networkMessage =
    //             'Your connection level is low and may impact the filling of your session for the day.';
    //     } else {
    //         this.networkStatus = 'success';
    //         this.networkMessage = 'Your connection level is sufficient or very good.';
    //     }
    // }

    this.checking = false;
    this.isChecked = true;
  }
}
